import { render, staticRenderFns } from "./bindAskbotClient.vue?vue&type=template&id=486e68f6&scoped=true"
import script from "./bindAskbotClient.vue?vue&type=script&lang=js"
export * from "./bindAskbotClient.vue?vue&type=script&lang=js"
import style0 from "./bindAskbotClient.vue?vue&type=style&index=0&id=486e68f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e68f6",
  null
  
)

export default component.exports